var AlyleServiceConfig = /** @class */ (function () {
    function AlyleServiceConfig() {
    }
    return AlyleServiceConfig;
}());
export { AlyleServiceConfig };
//# sourceMappingURL=alyle-config-service.js.map